import React from 'react';

// CoinGecko attribution required by the Analyst plan licence (CoinGecko legal, 2026-10-02): BOTH "Powered by CoinGecko"
// (font size 10 or larger) and "Data provided by CoinGecko" linked to coingecko.com/en/api, near the data on every page,
// chart and report where CoinGecko values (or figures derived from them) appear. Wording only — no logo, no claim of
// partnership or endorsement (brand.coingecko.com attribution guide).
export const COINGECKO_API_URL = 'https://www.coingecko.com/en/api';

export default function CoinGeckoAttribution({ className = '', style }: { className?: string; style?: React.CSSProperties }) {
  const link: React.CSSProperties = { color: 'inherit', textDecoration: 'underline' };
  return (
    <span className={className} style={{ fontSize: 11, ...style }} data-attribution="coingecko">
      <a href={COINGECKO_API_URL} target="_blank" rel="noopener noreferrer" style={link}>Powered by CoinGecko</a>
      <span aria-hidden style={{ margin: '0 6px' }}>·</span>
      <a href={COINGECKO_API_URL} target="_blank" rel="noopener noreferrer" style={link}>Data provided by CoinGecko</a>
    </span>
  );
}
